import { useState, useEffect } from 'react';

export function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem('cookie_consent')) setVisible(true);
  }, []);

  const grant = () => {
    localStorage.setItem('cookie_consent', 'granted');
    window.gtag?.('consent', 'update', { analytics_storage: 'granted' });
    setVisible(false);
  };

  const deny = () => {
    localStorage.setItem('cookie_consent', 'denied');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-background border-t border-border px-4 py-3 flex flex-col sm:flex-row gap-3 items-start sm:items-center justify-between">
      <p className="text-sm text-muted-foreground max-w-2xl">
        Usamos cookies de analytics para entender como o site é utilizado e melhorá-lo.
        Nenhum dado é compartilhado com terceiros para fins publicitários.{' '}
        <a href="/politica-de-privacidade" className="underline underline-offset-2 hover:text-foreground transition-colors">
          Política de Privacidade
        </a>
        .
      </p>
      <div className="flex gap-2 shrink-0">
        <button
          onClick={deny}
          className="text-sm px-4 py-2 border border-border rounded-md hover:bg-muted transition-colors"
        >
          Rejeitar
        </button>
        <button
          onClick={grant}
          className="text-sm px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors"
        >
          Aceitar
        </button>
      </div>
    </div>
  );
}
